import App from "./App.svelte"
import { mount } from "svelte"
import { determinePageCluster } from "./tracking/pageCluster"
import { submitEvent } from "@otto-ec/tracking-bct"

function initTracking() {
    const flyoutPopover = document.querySelector(".fti-fly-js-popover")
    if (!flyoutPopover) return

    flyoutPopover.addEventListener("oc-popover-open", () => {
        void submitEvent({
            aftersales_NaviSource: [determinePageCluster() || ""],
            aftersales_NaviType: ["MeinKontoHeader"],
            aftersales_NaviActivity: ["Flyout_open"],
        })
    })

    flyoutPopover.addEventListener("oc-popover-close", () => {
        void submitEvent({
            aftersales_NaviType: ["MeinKontoHeader"],
            aftersales_NaviActivity: ["Flyout_close"],
        })
    })
}

export function activateFallback(reason: unknown) {
    console.error("[fti_flyout] Svelte hydration failed, activating fallback", reason)
    const overlay = document.getElementById("fti-fly-icon-overlay")
    if (overlay) {
        overlay.setAttribute("href", btoa("/customer-identity/login?entryPoint=loginArea"))
        overlay.setAttribute("rel", "nofollow")
    }
}

export function initFlyout() {
    const iconDiv = document.querySelector(".fti-fly-js-my-account-icon")
    const target = iconDiv?.parentElement

    if (!iconDiv || !target) {
        activateFallback("Missing DOM elements")
        return
    }

    initTracking()

    try {
        mount(App, {
            target,
            anchor: iconDiv.nextSibling ?? undefined,
        })
    } catch (e) {
        activateFallback(e)
    }
}
